"use strict";
"use client";
import { useState, useEffect } from "react";
import { getDefaultLocale } from "../../util/i18n.js";
const listeners = /* @__PURE__ */ new Set();
function updateLocale() {
  const currentLocale = getDefaultLocale();
  for (const listener of listeners) {
    listener(currentLocale);
  }
}
function useLocale(customLocale) {
  const [locale, setLocale] = useState(getDefaultLocale());
  useEffect(() => {
    if (customLocale) {
      return void 0;
    }
    setLocale(getDefaultLocale());
    if (listeners.size === 0) {
      window.addEventListener("languagechange", updateLocale);
    }
    listeners.add(setLocale);
    return () => {
      listeners.delete(setLocale);
      if (listeners.size === 0) {
        window.removeEventListener("languagechange", updateLocale);
      }
    };
  }, [customLocale]);
  return customLocale || locale;
}
export {
  useLocale
};
